const parameterTranslation = (parameterSourceId: string) => {
  switch (parameterSourceId) {
    // Вызов вверх <Номер этажа>
    case 'mC1_SK1':
      return 'Вв1'
    case 'mC1_SK2':
      return 'Вв2'
    case 'mC1_SK3':
      return 'Вв3'
    case 'mC1_SK4':
      return 'Вв4'
    case 'mC2_SK1':
      return 'Вв5'
    case 'mC2_SK2':
      return 'Вв6'
    case 'mC2_SK3':
      return 'Вв7'
    case 'mC2_SK4':
      return 'Вв8'
    case 'mC3_SK1':
      return 'Вв9'
    case 'mC3_SK2':
      return 'Вв10'
    case 'mC3_SK3':
      return 'Вв11'
    case 'mC3_SK4':
      return 'Вв12'
    case 'mC4_SK1':
      return 'Вв13'
    case 'mC4_SK2':
      return 'Вв14'
    case 'mC4_SK3':
      return 'Вв15'
    case 'mC4_SK4':
      return 'Вв16'
    case 'mC1_SK17':
      return 'Вв17'
    case 'mC1_SK18':
      return 'Вв18'
    case 'mC1_SK19':
      return 'Вв19'
    case 'mC1_SK20':
      return 'Вв20'
    case 'mC2_SK17':
      return 'Вв21'
    case 'mC2_SK18':
      return 'Вв22'
    case 'mC2_SK19':
      return 'Вв23'
    case 'mC2_SK20':
      return 'Вв24'
    case 'mC3_SK17':
      return 'Вв25'
    case 'mC3_SK18':
      return 'Вв26'
    case 'mC3_SK19':
      return 'Вв27'
    case 'mC3_SK20':
      return 'Вв28'
    case 'mC4_SK17':
      return 'Вв29'
    case 'mC4_SK18':
      return 'Вв30'
    case 'mC4_SK19':
      return 'Вв31'
    case 'mC4_SK20':
      return 'Вв32'
    // Вызов вниз <Номер этажа>
    case 'mC5_SK2':
      return 'Вн2'
    case 'mC5_SK3':
      return 'Вн3'
    case 'mC5_SK4':
      return 'Вн4'
    case 'mC6_SK1':
      return 'Вн5'
    case 'mC6_SK2':
      return 'Вн6'
    case 'mC6_SK3':
      return 'Вн7'
    case 'mC6_SK4':
      return 'Вн8'
    case 'mC7_SK1':
      return 'Вн9'
    case 'mC7_SK2':
      return 'Вн10'
    case 'mC7_SK3':
      return 'Вн11'
    case 'mC7_SK4':
      return 'Вн12'
    case 'mC8_SK1':
      return 'Вн13'
    case 'mC8_SK2':
      return 'Вн14'
    case 'mC8_SK3':
      return 'Вн15'
    case 'mC8_SK4':
      return 'Вн16'
    case 'mC5_SK17':
      return 'Вн17'
    case 'mC5_SK18':
      return 'Вн18'
    case 'mC5_SK19':
      return 'Вн19'
    case 'mC5_SK20':
      return 'Вн20'
    case 'mC6_SK17':
      return 'Вн21'
    case 'mC6_SK18':
      return 'Вн22'
    case 'mC6_SK19':
      return 'Вн23'
    case 'mC6_SK20':
      return 'Вн24'
    case 'mC7_SK17':
      return 'Вн25'
    case 'mC7_SK18':
      return 'Вн26'
    case 'mC7_SK19':
      return 'Вн27'
    case 'mC7_SK20':
      return 'Вн28'
    case 'mC8_SK17':
      return 'Вн29'
    case 'mC8_SK18':
      return 'Вн30'
    case 'mC8_SK19':
      return 'Вн31'
    case 'mC8_SK20':
      return 'Вн32'

    // Режим приоритетного доступа, срабатывает когда есть NFC метка
    case 'mC5_SK1':
      return 'VIP'

    // Приказы
    case 'mC1_SK5':
      return 'Пр1'
    case 'mC1_SK6':
      return 'Пр2'
    case 'mC2_SK5':
      return 'Пр3'
    case 'mC2_SK6':
      return 'Пр4'
    case 'mC3_SK5':
      return 'Пр5'
    case 'mC3_SK6':
      return 'Пр6'
    case 'mC4_SK5':
      return 'Пр7'
    case 'mC4_SK6':
      return 'Пр8'
    case 'mC5_SK5':
      return 'Пр9'
    case 'mC5_SK6':
      return 'Пр10'
    case 'mC6_SK5':
      return 'Пр11'
    case 'mC6_SK6':
      return 'Пр12'
    case 'mC7_SK5':
      return 'Пр13'
    case 'mC7_SK6':
      return 'Пр14'
    case 'mC8_SK5':
      return 'Пр15'
    case 'mC8_SK6':
      return 'Пр16'
    case 'mC1_SK21':
      return 'Пр17'
    case 'mC1_SK22':
      return 'Пр18'
    case 'mC2_SK21':
      return 'Пр19'
    case 'mC2_SK22':
      return 'Пр20'
    case 'mC3_SK21':
      return 'Пр21'
    case 'mC3_SK22':
      return 'Пр22'
    case 'mC4_SK21':
      return 'Пр23'
    case 'mC4_SK22':
      return 'Пр24'
    case 'mC5_SK21':
      return 'Пр25'
    case 'mC5_SK22':
      return 'Пр26'
    case 'mC6_SK21':
      return 'Пр27'
    case 'mC6_SK22':
      return 'Пр28'
    case 'mC7_SK21':
      return 'Пр29'
    case 'mC7_SK22':
      return 'Пр30'
    case 'mC8_SK21':
      return 'Пр31'
    case 'mC8_SK22':
      return 'Пр32'

    // Многофункциональные входы
    case 'mC1_SK23':
      return 'MFI9'
    case 'mC1_SK24':
      return 'MFI8'
    case 'mC2_SK23':
      return 'MFI10'
    case 'mC3_SK23':
      return 'MFI7'
    case 'mC4_SK23':
      return 'ФЗА'
    case 'mC5_SK23':
      return 'ФЗБ'
    case 'mC6_SK23':
      return 'ППП'
    case 'mC7_SK23':
      return 'ВЛК'
    case 'mC8_SK23':
      return 'ВОК'
    case 'mC2_SK24':
      return 'БМ'
    case 'mC3_SK24':
      return 'ДВВ'
    case 'mC4_SK24':
      return 'ДВН'
    case 'mC5_SK24':
      return 'ДВЭ1'
    case 'mC6_SK24':
      return 'ДНЭ1'
    case 'mC7_SK24':
      return 'ДВЭ2'
    case 'mC8_SK24':
      return 'ДНЭ2'
    case 'mC1_SK9':
      return 'HS'
    case 'mC2_SK9':
      return 'LS'
    case 'mC3_SK9':
      return 'DEC'
    case 'mC4_SK9':
      return 'RES'
    case 'mC5_SK9':
      return 'UP'
    case 'mC6_SK9':
      return 'Down'
    case 'mC7_SK9':
      return 'А.Дв'
    case 'mC8_SK9':
      return 'MF4'

    case 'mC1_SK10':
      return 'SELT'
    case 'mC2_SK10':
      return 'ОД1'
    case 'mC3_SK10':
      return 'ОД2'
    case 'mC4_SK10':
      return 'ЗД'
    case 'mC5_SK10':
      return 'STO'

    case 'mC1_SK15':
      return 'ДК-А'
    case 'mC2_SK15':
      return 'ДК-Б'
    case 'mC3_SK15':
      return 'ДШ'

    case 'mC1_SK7':
      return 'ОТК'
    case 'mC2_SK7':
      return 'ОТМ'
    case 'mC3_SK7':
      return 'ЗАКР'
    case 'mC4_SK7':
      return 'Гр15'
    case 'mC5_SK7':
      return 'Гр90'
    case 'mC6_SK7':
      return 'Гр110'
    case 'mC7_SK7':
      return 'MFI4'
    case 'mC8_SK7':
      return 'MFI2'

    case 'mC1_SK8':
      return 'ВКО'
    case 'mC2_SK8':
      return 'ВКЗ'
    case 'mC3_SK8':
      return 'ВБР'
    case 'mC4_SK8':
      return 'ПРВ'
    case 'mC5_SK8':
      return 'MFI1'
    case 'mC6_SK8':
      return 'MFI5'
    case 'mC7_SK8':
      return 'Вент'
    case 'mC8_SK8':
      return 'MFI3'

    default:
      return null
  }
}

const getParameterColorDescriptor = (parameterSourceId: string) => {
  const translation = parameterTranslation(parameterSourceId)

  if (!translation) {
    return 'unknown'
  }

  if (translation.startsWith('Вв')) {
    return 'up-call'
  }

  if (translation.startsWith('Вн')) {
    return 'down-call'
  }

  if (translation.startsWith('Пр')) {
    return 'order'
  }
}

const getParameterTooltipText = (parameterSourceId: string) => {
  const translation = parameterTranslation(parameterSourceId)
  if (!translation) {
    return null
  }

  if (translation.startsWith('Вв')) {
    return 'Вызов вверх, этаж ' + translation.substring(2)
  }

  if (translation.startsWith('Вн')) {
    return 'Вызов вниз, этаж ' + translation.substring(2)
  }

  if (translation.startsWith('Пр')) {
    return 'Приказ на этаж ' + translation.substring(2)
  }

  if (translation.startsWith('MFI')) {
    return 'Многофункциональный выход'
  }

  if (translation === 'VIP') {
    return 'Режим приоритетного доступа, срабатывает по NFC метке'
  }

  if (translation === 'ОТК') {
    return 'Зажата кнопка открытия дверей'
  }

  if (translation === 'ОТМ') {
    return 'Нажатие кнопки отмена, либо срабатывание фотозавесы, либо механическая преграда в дверях'
  }

  if (translation === 'ЗАКР') {
    return 'Зажата кнопка закрытия дверей'
  }

  if (translation === 'Гр15') {
    return 'Сигнал грузовеса 15кг'
  }

  if (translation === 'Гр90') {
    return 'Сигнал грузовеса 90%'
  }

  if (translation === 'Гр110') {
    return 'Сигнал грузовеса 110%'
  }

  if (translation === 'ВКО') {
    return 'Сигнал открытия дверей'
  }

  if (translation === 'ВКЗ') {
    return 'Сигнал закрытия дверей'
  }

  if (translation === 'ВБР') {
    return 'Сигнал реверса дверей'
  }

  if (translation === 'Вент') {
    return 'Вентиляция'
  }

  if (translation === 'ДК-А') {
    return 'Дверь кабины открыты сторона А'
  }

  if (translation === 'ДК-Б') {
    return 'Дверь кабины открыты сторона Б'
  }

  if (translation === 'ДШ') {
    return 'Двери шахты'
  }

  if (translation === 'ВОК') {
    return 'Верхнее ограничение кабины'
  }

  if (translation === 'БМ') {
    return 'Безопасный мост'
  }

  if (translation === 'ДВВ') {
    return 'датчик выравнивания вверх'
  }

  if (translation === 'ДВН') {
    return 'Датчик выравнивания вниз'
  }

  if (translation === 'ДВЭ1' || translation === 'ДВЭ2') {
    return 'Датчик крайнего верхнего этажа'
  }

  if (translation === 'ДНЭ1' || translation === 'ДНЭ2') {
    return 'Датчик нижнего этажа'
  }

  if (translation === 'ППП') {
    return 'Перевозка пожарных подразделений'
  }

  if (translation === 'ВЛК') {
    return 'Верхний люк кабины'
  }

  if (translation === 'ФЗА') {
    return 'Фотозавеса сторона А'
  }

  if (translation === 'ФЗБ') {
    return 'Фотозавеса сторона Б'
  }

  if (translation === 'ПРВ') {
    return 'Режим погрузки'
  }
}

const liftPlateContactMatrixUtils = { parameterTranslation, getParameterColorDescriptor, getParameterTooltipText }
export default liftPlateContactMatrixUtils
